import React, { useState } from 'react';
import { FeatureHighScoreView } from './FeatureHighScore.view';
import { ImagesLots } from '../../../../types/Lots';

export interface FeatureHighScoreProps {
  users: any;
  img?: ImagesLots;
  type: 'classe' | 'academie' | 'niveau' | 'national';
}

export const FeatureHighScore = ({
  users,
  img,
  type
}: FeatureHighScoreProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onChange = () => {
    setIsOpen(!isOpen);
  };

  return (
    <FeatureHighScoreView
      users={users}
      img={img}
      onChange={onChange}
      isOpen={isOpen}
      // onlyFirst={type !== 'classe' && true} // si on veut afficher le lot que pour le premier
      onlyFirst={true}
    />
  );
};
